import * as React from "react";
import { Link, useNavigate } from "@tanstack/react-router";
import { Boton } from "@iavmx/ui";
import { MarcoAcceso, Mensaje } from "../componentes";
import { useSesion } from "../sesion";

export function Entrar() {
  const { cargando, cliente, correo, estadoYo, entrarConGoogle } = useSesion();
  const navegar = useNavigate();
  const [error, setError] = React.useState<string | null>(null);
  const [ocupado, setOcupado] = React.useState(false);

  React.useEffect(() => {
    if (correo && estadoYo === "ok") void navegar({ to: "/", replace: true });
  }, [correo, estadoYo, navegar]);

  async function google() {
    setOcupado(true);
    setError(null);
    const r = await entrarConGoogle();
    if (r.error) setError(r.error);
    setOcupado(false);
  }

  return (
    <MarcoAcceso>
      <div className="space-y-5">
        <div>
          <h1 className="font-titulo text-3xl font-bold leading-tight sm:text-4xl">Entra a iavmx</h1>
          <p className="mt-2 font-ui text-sm text-tinta-tenue">
            Las herramientas de IA de Vanguardia, en un solo lugar. Usa la cuenta con la que abres tu correo del trabajo.
          </p>
        </div>
        {correo && estadoYo === "sin_directorio" && (
          <Mensaje tono="info" titulo="Ya hay una sesión, pero sin acceso.">
            Entraste como <b>{correo}</b>.{" "}
            <Link to="/auth/confirmar" className="text-azul underline-offset-4 hover:underline">
              Ver por qué
            </Link>
            .
          </Mensaje>
        )}
        {!cliente && !cargando && (
          <Mensaje tono="info" titulo="El acceso no está configurado en este entorno.">
            Faltan SUPABASE_URL y SUPABASE_ANON_KEY en .dev.vars.
          </Mensaje>
        )}
        <Boton
          variante="acento"
          tamano="lg"
          className="h-12 w-full whitespace-normal text-tinta"
          onClick={() => void google()}
          disabled={cargando || !cliente || ocupado}
        >
          {ocupado ? "Abriendo Google…" : "Entrar con tu cuenta de Google de Vanguardia"}
        </Boton>
        {error && <Mensaje tono="info">{error}</Mensaje>}
        <div className="flex items-center gap-3 font-ui text-xs text-tinta-tenue before:h-px before:flex-1 before:bg-linea after:h-px after:flex-1 after:bg-linea">
          o
        </div>
        <Boton variante="contorno" tamano="lg" className="h-11 w-full" asChild>
          <Link to="/entrar/invitacion">Recibí una invitación por correo</Link>
        </Boton>
        <hr className="border-linea" />
        <p className="font-ui text-xs leading-relaxed text-tinta-tenue">
          Solo entra el personal de Vanguardia con cuenta @vanguardia.com.mx que ya fue invitado. Si todavía no tienes acceso, pídeselo a tu jefe de área o a quien administra iavmx en Estrategia Digital.
        </p>
      </div>
    </MarcoAcceso>
  );
}
